<template>
  <v-container
    class="align-content-start"
    fill-height
    fluid
  >
    <v-row>
      <section-header :breadcrumb-items="breadcrumb" />
    </v-row>

    <v-row>
      <v-col cols="12">
        <liquidity-risk />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <interest-rate-risk />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <market-data />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import SectionHeader                     from '@/theme/default/components/common/SectionHeader'
import API                               from '@/api/Api'
import { clone }                         from '@/lib/utils/helper'
import Socket                            from '@/theme/default/views/dashboard/socket/socket'
import LiquidityRisk from '@/theme/default/views/banking/dashboard/LiquidityRisk.vue'
import InterestRateRisk from '@/theme/default/views/banking/dashboard/InterestRateRisk.vue'
import MarketData from '@/theme/default/views/banking/dashboard/MarketData.vue'

export default {
  name      : 'Dashboard',
  components: {
    MarketData,
    InterestRateRisk,
    LiquidityRisk,
    SectionHeader
  },
  directives: {},
  mixins    : [i18nRouteMeta],
  props     : {},
  dataStore : {
    appToolbarExtended  : 'App.Config.AppToolbarExtended',
    bankingDashboardData: 'BankingDashboard.Data'
  },
  enums: {},
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('Dashboard.HeaderTitle', { Name: this.userName }),
        disabled: true
      }]
    },

    userName () {
      return this.user?.firstName || null
    },

    accountId () {
      return this.user?.selectedAccountId || null
    }

  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }

  },
  beforeCreate () {
    Socket.init()
  },
  created () {
    this.getDashboardData()
  },
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {
    Socket.close()
  },
  destroyed () {},
  methods: {
    getDashboardData () {
      API.Resource.BankingDashboard.GetBankingDashboard(this.accountId)
        .then(response => {
          this.handleBankingDashboardResponse(response)
        })
        .catch(e => {
          this.handleBankingDashboardResponse(e.response)
        })
        .finally(() => {})
    },
    handleBankingDashboardResponse (response) {
      const data = API.responseData(response)?.bankingDashboard || null
      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.bankingDashboardData = o
      } else {
        this.bankingDashboardData = null
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
</script>

<style scoped>

</style>
